import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  MessageBox,
  MessageStates,
  NORMAL_TIMEOUT,
  ERROR_TIMEOUT,
  type MessageData,
} from '@monorepo/shared-lib';
import { turnMessageOff } from 'store/app/actions';
import { getMessage, getShowMessage } from 'store/app/selectors';

export { MessageStates, NORMAL_TIMEOUT, ERROR_TIMEOUT };
export type { MessageData };

/** App Redux adapter around shared MessageBox */
export const MessageBoxContainer: React.FC = () => {
  const dispatch = useDispatch();
  const showMessage = useSelector(getShowMessage);
  const message = useSelector(getMessage);

  const onDismiss = React.useCallback(() => {
    dispatch(turnMessageOff());
  }, [dispatch]);

  return (
    <MessageBox
      showMessage={!!showMessage}
      message={message}
      onDismiss={onDismiss}
    />
  );
};
